import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  container: {
    boxShadow: '1px 1px 8px hsla(0, 0%, 40%, 0.3)',
    display: 'flex',
    flexWrap: 'Wrap',
    margin: '80px auto 45vh',
    maxWidth: 400,
    minWidth: 50,
    padding: 30,
    backgroundSize: 'cover',
    borderRadius: 10,
    textAlign: 'center',
    [theme.breakpoints.down(400)]: {
      maxWidth: 'auto',
    },
  },
}));
